export default "__VITE_ASSET__C7Oiu1Cx__"